import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = {
  key: 0,
  class: "h-3 w-3 border-2 border-[#E63415] rounded-sm mr-1"
}
const _hoisted_3 = {
  key: 1,
  class: "h-3 w-3 bg-[#E63415] rounded-sm mr-1"
}
const _hoisted_4 = {
  key: 2,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_5 = {
  key: 3,
  class: "h-3 w-3 border-2 border-[#FF6600] rounded-sm mr-1"
}
const _hoisted_6 = {
  key: 4,
  class: "h-3 w-3 bg-[#FF6600] rounded-sm mr-1"
}
const _hoisted_7 = {
  key: 5,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_8 = {
  key: 6,
  class: "h-3 w-3 border-2 border-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_9 = {
  key: 7,
  class: "h-3 w-3 bg-[#FFDE0A] rounded-sm mr-1"
}
const _hoisted_10 = {
  key: 8,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_11 = {
  key: 9,
  class: "h-3 w-3 border-2 border-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_12 = {
  key: 10,
  class: "h-3 w-3 bg-[#1EC79D] rounded-sm mr-1"
}
const _hoisted_13 = {
  key: 11,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_14 = {
  key: 12,
  class: "h-3 w-3 border-2 border-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_15 = {
  key: 13,
  class: "h-3 w-3 bg-[#14CCCC] rounded-sm mr-1"
}
const _hoisted_16 = {
  key: 14,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}
const _hoisted_17 = {
  key: 15,
  class: "h-3 w-3 border-2 border-[#4167F0] rounded-sm mr-1"
}
const _hoisted_18 = {
  key: 16,
  class: "h-3 w-3 bg-[#4167F0] rounded-sm mr-1"
}
const _hoisted_19 = {
  key: 17,
  class: "h-3 w-3 bg-gray-400 rounded-sm mr-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.item.check_result1 === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_ctx.item.check_result1 === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4)),
    (_ctx.item.check_result2 === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5))
      : (_ctx.item.check_result2 === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6))
        : (_openBlock(), _createElementBlock("div", _hoisted_7)),
    (_ctx.item.check_result3 === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_8))
      : (_ctx.item.check_result3 === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9))
        : (_openBlock(), _createElementBlock("div", _hoisted_10)),
    (_ctx.item.check_result4 === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11))
      : (_ctx.item.check_result4 === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12))
        : (_openBlock(), _createElementBlock("div", _hoisted_13)),
    (_ctx.item.check_result5 === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14))
      : (_ctx.item.check_result5 === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15))
        : (_openBlock(), _createElementBlock("div", _hoisted_16)),
    (_ctx.item.check_result6 === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17))
      : (_ctx.item.check_result6 === 2)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18))
        : (_openBlock(), _createElementBlock("div", _hoisted_19))
  ]))
}